import React, { useState } from "react";
import MainHeader from "../components/MainHeader";
import { useNavigate } from "react-router-dom";
import Toast from "../components/Toast";

import {
  getDownloadURL,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import { imgDb } from "../utils/firebase";
import { v4 } from "uuid";
import { sendData } from "../utils/auth";
import DataInput from "../components/DataInput";

const InputPage = () => {
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [ifile, setIfile] = useState(null);
  const [image, setImage] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const navigate = useNavigate();

  const handleSuccess = () => {
    setShowSuccessToast(true);
    setTimeout(() => {
      setShowSuccessToast(false);
    }, 3000);
  };

  const handleError = () => {
    setShowErrorToast(true);
    setTimeout(() => {
      setShowErrorToast(false);
    }, 3000);
  };

  const handleUpload = (e) => {
    const file = e.target.files[0];
    setIfile(file);
    const imgs = ref(imgDb, `Imgs/${v4()}`);
    const uploadTask = uploadBytesResumable(imgs, file);
    // const desiredDuration = 6000; // 6 seconds in milliseconds
    // const totalBytes = file.size;
    // const bytesPerSecond = totalBytes / desiredDuration;

    // let uploadedBytes = 0;
    // let startTime = null;

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
        (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
       
        setUploadProgress(progress);
      },
      (error) => {
        console.error("Error uploading image: ", error);
      },
      () => {
        // Upload completed successfully
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setImage(downloadURL);
          setTimeout(() => {
            // setUploadProgress(0);
          }, 2000); // Reset progress after 2 seconds
        });
        handleSuccess();
      }
    );
  };

  const handleSendData = async() => {
    if (age && gender && image) {
      const res =await sendData({ age, gender, image,ifile });
      if(res===null){
        navigate('/');
      }
      handleSuccess();
      // navigate('/result');
      navigate('/result', { state: { age,gender, image,res } });
    } else {
      handleError();
    }
  };


  return (
    <div>
      <MainHeader />
      <DataInput
        age={age}
        setAge={setAge}
        gender={gender}
        setGender={setGender}
        handleSendData={handleSendData}
        handleUpload={handleUpload}
        uploadProgress={uploadProgress}
      />
      {showSuccessToast && (
        <Toast
          message="Success! Your action was completed."
          type="success"
          onClose={() => setShowSuccessToast(false)}
        />
      )}
      {showErrorToast && (
        <Toast
          message="Form not complete"
          type="error"
          onClose={() => setShowErrorToast(false)}
        />
      )}
    </div>
  );
};

export default InputPage;
